import { PrimaryButton, TertiaryButton } from '@ardoq/button';
import { colors } from '@ardoq/design-tokens';
import { Icon, IconName } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { type I18nLocale, t } from '@ardoq/i18n';
import { InventoryInteractiveTopRowCommands } from './types';
import { TableControlsInteractiveRow } from './TableControlsInteractiveRow';

type CreateComponentsInteractiveRowProps = {
  commands: InventoryInteractiveTopRowCommands;
  i18nLocale: I18nLocale;
};

export const CreateComponentsInteractiveRow = ({
  commands,
  i18nLocale,
}: CreateComponentsInteractiveRowProps) => {
  return (
    <TableControlsInteractiveRow i18nLocale={i18nLocale}>
      <FlexBox align="center" gap="xsmall">
        <Icon iconName={IconName.COMPONENT} color={colors.iconAction} />
        <span>
          {t(
            i18nLocale,
            'inventory:interactiveRow.creatingComponentMessage',
            'Creating component. Give the component a name, then hit Enter to add another.'
          )}
        </span>
      </FlexBox>
      <FlexBox align="center" gap="xsmall">
        <PrimaryButton onClick={commands.exitCreateComponentsMode}>
          {t(
            i18nLocale,
            'inventory:interactiveRow.finishEditing',
            'Finish editing'
          )}
        </PrimaryButton>
        <TertiaryButton onClick={commands.addNewRow}>
          {t(i18nLocale, 'inventory:interactiveRow.newRow', 'New row')}
          <Icon iconName={IconName.LEVEL_LEFT} />
        </TertiaryButton>
      </FlexBox>
    </TableControlsInteractiveRow>
  );
};
